import { render, staticRenderFns } from "./Autopurge.vue?vue&type=template&id=aad8f04e"
import script from "./Autopurge.vue?vue&type=script&lang=js"
export * from "./Autopurge.vue?vue&type=script&lang=js"
import style0 from "./Autopurge.vue?vue&type=style&index=0&id=aad8f04e&prod&lang=css"
import style1 from "spinkit/spinkit.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports